import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useIntl, defineMessages } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { Error } from '@plone/volto/components';
import { BodyClass, Helmet } from '@plone/volto/helpers';
import {
  Icon,
  RemoveBodyClass,
} from 'design-comuni-plone-theme/components/ItaliaTheme';
import {
  Col,
  Container,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
} from 'design-react-kit';
import { Appuntamenti } from '@redturtle/volto-io-prenoto/components/View/AreaPersonaleView';

/* STYLE */
import '@redturtle/volto-io-prenoto/components/View/AreaPersonaleView/AreaPersonaleView.scss';
import { getPrenotazioniList } from '@redturtle/volto-io-prenoto/actions/booking';

const messages = defineMessages({
  area_personale_title: {
    id: 'booking_area_personale_title',
    defaultMessage: 'Area personale',
  },
  menu_bookings: {
    id: 'booking_menu_bookings',
    defaultMessage: 'Prenotazione appuntamenti',
  },
  current: {
    id: 'booking_current_menu',
    defaultMessage: 'Menu selezionato',
  },
});
const AreaPersonaleView = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const [activeTab, toggleTab] = useState('1');

  const userData = useSelector((state) => state.users.user);
  const isLoggedIn = useSelector((state) => state.userSession.token);

  const bookings = useSelector((state) => state.prenotazioniList);

  const loadBookings = () => {
    dispatch(getPrenotazioniList({ folderPath: '/', sort_on: 'Date', sort_order: 'descending', fullObjects: true }));
  };

  /* GET BOOKINGS */
  useEffect(() => {
    userData.id && loadBookings();
  }, [dispatch, userData]);

  // Handle not user logged
  if (!isLoggedIn) {
    return <Error error={{ status: 401, message: 'Unauthorized' }} />;
  }

  return (
    <>
      <BodyClass className="public-ui" />
      <RemoveBodyClass className="cms-ui" />
      <Container className="px-4 my-4 area-personale-view">
        <Helmet title={intl.formatMessage(messages.area_personale_title)} />
        <Col xs="12" lg="10">
          {/* USER INFO */}
          <div className="heading py-3 pb-lg-4">
            <h1 className="heading-title">{userData.fullname}</h1>
            <p className="heading-cfiscale text-uppercase">
              CF:{' '}
              {userData?.id && userData?.id.includes('tinit-')
                ? userData?.id.substring(userData?.id.indexOf('-') + 1)
                : userData?.id}
            </p>
          </div>
        </Col>

        {/* TABS */}
        <Row>
          <Col xs="12" className="p-0">
            {/* TABS */}
            <Nav tabs className="w-100 auto mb-4">
              <NavItem className="w-100 p-1">
                <NavLink
                  className="justify-content-start me-lg-3"
                  active={activeTab === '1'}
                  onClick={() => {
                    if (activeTab !== '1') {
                      toggleTab('1');
                    }
                  }}
                >
                  <Icon
                    color="primary"
                    className="icon-small px-2"
                    icon="it-clock"
                    key="it-clock"
                  />
                  {intl.formatMessage(messages.menu_bookings)}
                  {activeTab === '1' && (
                    <span className="visually-hidden">
                      {intl.formatMessage(messages.current)}
                    </span>
                  )}
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
        </Row>
        <TabContent activeTab={activeTab}>
          <Appuntamenti
            userId={userData.id}
            bookings={bookings}
            loadBookings={loadBookings}
          />
        </TabContent>
      </Container>
    </>
  );
};

AreaPersonaleView.propTypes = {
  content: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
  }),
  token: PropTypes.string,
};

export default AreaPersonaleView;
